// extracted by mini-css-extract-plugin
export var accordion = "styles-module--accordion--d9f4f";
export var content = "styles-module--content--914ef";
export var dark = "styles-module--dark--172f7";
export var hideMobile = "styles-module--hideMobile--8d9b5";
export var image = "styles-module--image--31559";
export var light = "styles-module--light--17ede";
export var panel = "styles-module--panel--a4e47";
export var title = "styles-module--title--3e96b";
export var wrapper = "styles-module--wrapper--3be25";